import React from 'react';
import { ToastContainer } from 'react-toastify';
import { useTheme } from '../../context/ThemeContext';
import { useCheckinNotifications } from './useCheckinNotifications';

function GlobalCheckinNotifier() {
  const { isDark } = useTheme();
  useCheckinNotifications();

  return (
    <ToastContainer
      position="top-right"
      autoClose={2800}
      newestOnTop
      pauseOnFocusLoss={false}
      theme={isDark ? 'dark' : 'light'}
    />
  );
}

export default GlobalCheckinNotifier;
